<template>
	<transition name="fade">
		<el-dialog :visible.sync="dialogVisible" :append-to-body="true" width="340px">
			<div class="v-passport-box" v-if="dialogVisible">
				<el-tabs v-model="tab" :stretch="true" v-if="tab=='Login' || tab=='Register'">
					<el-tab-pane label="登录" name="Login"></el-tab-pane>
					<el-tab-pane label="注册" name="Register"></el-tab-pane>
				</el-tabs>
				<transition name="fade" mode="out-in">
					<component :is="tab"></component>
				</transition>
			</div>
		</el-dialog>
	</transition>
</template>

<script>
import Login from "@/components/Passport/Login";
import Register from "@/components/Passport/Register";
import ResetPassword from "@/components/Passport/ResetPassword";

export default {
	name: "Passport",
	props: ['token'],
	components: { Login, Register, ResetPassword },
	data() {
		return {
			tab: "Login",
			dialogVisible: false
		};
	},
	methods: {
		show(tab) {
			this.dialogVisible = true;
			if (tab) {
				tab = tab.charAt(0).toUpperCase() + tab.slice(1);
				this.tab = tab;
			}
		},
		hide() {
			this.dialogVisible = false;
		},
		initUser() {
			// 检查缓存中有用户token，则初始化用户信息
			if (this.$store.getters.token) {
				this.axios
					.get(this.axios.apiGateway + "user/getUserInfo", {
						params: {
							token: this.$store.getters.token
						}
					})
					.then(res => {
						if (!res.data.errcode) {
							this.$store.dispatch('login', res.data)
						} else {
							this.$store.dispatch('logout')
						}
					});
			}
		}
	},
	created() {
		
		this.initUser()

		this.util.$on("login", res => {
			this.show("login")
		})
		this.util.$on("register", res => {
			this.show("register")
		})
		this.util.$on("forgetPassword", res => {
			this.show("resetPassword")
    })
    this.util.$on("closePassport", res => {
			this.hide()
		})
		this.util.$on("logout", res => {
			this.$store.dispatch('logout')
			this.$notify({
				title: '退出成功',
				message: '当前用户已退出。',
				type: 'success'
			})
		})
	}
};
</script>

<style lang="less">

.fade-enter-active, .fade-leave-active {
	transition: opacity .3s ease-in;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.v-passport-box {
	padding: 0 15px;
	margin-top: -30px;
	overflow: hidden;
	.caption {
		font-size: 24px;
		font-weight: 500;
		margin-top: 10px;
		margin-bottom: 30px;
	}
	.el-tabs {
		margin-bottom: 30px;
		.el-tabs__item {
			font-size: 1.15rem;
			height: 50px;
			line-height: 50px;
			letter-spacing: 1em;
			text-indent: 1em;
		}
	}
	.el-form-item {
		margin-bottom: 15px;
		&.el-form-action {
			padding-top: 5px;
		}
		.btn-send-sms {
			position: absolute;
			top: 1px;
			right: 15px;
			a {
				color: #999;
			}
		}
		.el-button {
			width: 100%;
			margin: 0 0 15px 0;
			&.wechat {
				background: green;
				border-color: green;
				color: #fff;
			}
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Passport.vue